import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectGeneralProject } from "../../redux/selectors";
import { useEffect, useState } from "react";
import { isEqual } from "lodash";
import useJobDetailsCheck from "../../functions/useJobDetailsCheck";

function JobGeneralOverview() {
  // Check if data exists in Redux before making any API calls
  const { hasData, data } = useJobDetailsCheck('generalProject');
  const storedJobDetails = useSelector(selectGeneralProject, isEqual);

  const [jobDetails, setJobDetails] = useState({});

  useEffect(() => {
    // Use data from Redux if available
    if (hasData && data.length > 0) {
      setJobDetails(data[0]);
    } else if (storedJobDetails.length > 0) {
      setJobDetails(storedJobDetails[0]);
    }
  }, [storedJobDetails, hasData, data]);

  return (
    <div>
      {jobDetails ? (
        <div className="flex-fill m-3">
          <Row>
            <Col className="text-center">
              <strong>
                {jobDetails.JobNumber} | {jobDetails.ProjectName}
              </strong>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">{jobDetails.ModelNumber}</Col>
          </Row>
          <Row>
            <Col className="text-center">
              <strong>Project Manager:</strong> {jobDetails.ProjectManager} |{" "}
              <strong>Sales Rep:</strong> {jobDetails.SalesRep}
            </Col>
          </Row>
          <Row><Col className="text-center">
            <i className="bi bi-wrench-adjustable"/> {jobDetails.MechanicalEngineer} | <i className="bi bi-plug-fill" /> {jobDetails.ElectricalEngineer} | <i className="bi bi-router" /> {jobDetails.ControlsEngineer}
            </Col></Row>
        </div>
      ) : (
        <p>No job details found.</p>
      )}
    </div>
  );
}

export default JobGeneralOverview;
